<template>
    <div id="authenticate">
        <b-container fluid
            id="container">
            <b-row no-gutters>
                <b-col id="left"
                    lg="6"
                    xl="6"></b-col>
                <b-col id="right"
                    sm="12"
                    md="12"
                    lg="6"
                    xl="6">
                    <b-row no-gutters>
                        <b-col cols="3"></b-col>
                        <b-col cols="6">
                            <a href="/"
                                class="logoHomeLink">
                                <logo-vertical></logo-vertical>
                            </a>
                            <tabs-menu></tabs-menu>
                            <login-form></login-form>
                        </b-col>
                        <b-col cols="3"></b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import LoginForm from '@/components/login/LoginForm.vue'
import TabsMenu from '@/components/login/TabsMenu.vue'
import LogoVertical from '@/components/ui/LogoVertical.vue'

export default {
    name: 'Login',
    components: {
        LoginForm,
        TabsMenu,
        LogoVertical
    }
}
</script>
